import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ProfilePageRoutingModule } from './profile-routing.module';

import { ProfilePage } from './profile.page';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslateModule } from '@ngx-translate/core';
import { MenuListComponent } from './menu-list/menu-list.component';
import { MenuComponent } from './menu/menu.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { TeamModule } from '../../team/team.module';
import { MatStepperModule } from '@angular/material/stepper';
import { SharedModule } from 'src/app/modules-config/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ProfilePageRoutingModule,
    MatTabsModule,
    TranslateModule.forChild(),
    MatStepperModule,
    TeamModule,
    SharedModule
  ],
  declarations: [ProfilePage,MenuListComponent,MenuComponent,UserProfileComponent],
  exports:[MenuListComponent]
})
export class ProfilePageModule {}
